import { motion } from "framer-motion";
import { Reveal } from "../../lib/motion";
import { IMAGES } from "../../lib/siteData";

export const Fidelity = () => {
  return (
    <section id="fidelity" data-testid="fidelity-section" className="relative py-28 lg:py-40">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-16 items-center">
          <Reveal className="lg:col-span-7">
            <div className="relative overflow-hidden h-[46vh] lg:h-[62vh]">
              <img
                src={IMAGES.mistyWater}
                alt="A person before a luminous presence, reflected on still water"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <motion.img
                src={IMAGES.fidelityClean}
                alt="A person before a luminous presence, reflected on still water"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: false, amount: 0.35 }}
                transition={{ duration: 5, ease: "easeInOut" }}
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-es-border" />
            </div>
          </Reveal>

          <div className="lg:col-span-4 lg:col-start-9">
            <Reveal>
              <p className="text-[11px] uppercase tracking-[0.4em] text-es-accent mb-6">
                Faithful, not invented
              </p>
              <h2 className="font-serif font-light text-es-fg text-[clamp(1.8rem,3.2vw,3rem)] tracking-tight leading-tight mb-6">
                Fidelity over illusion.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="text-es-muted-fg leading-relaxed mb-5">
                A personal AI should not be free to invent a person. Identity fidelity
                controls use approved memories, values, language, voice references,
                permissions, and defined boundaries to keep each representation faithful to
                the individual it represents.
              </p>
              <p className="text-es-muted-fg leading-relaxed">
                Every generated response identifies itself as AI and distinguishes original
                human material from AI generated interpretation.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-8 font-serif italic text-es-fg text-lg sm:text-xl leading-snug">
                When an authentic answer cannot be supported, the system should not pretend
                that one exists.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
